import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IActivateUserButton {
  userId: string;
}

const CustomConfirmButton = ({ userId }: IActivateUserButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatus, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `users/${userId}/activate`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully activate user.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed activate the user, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Button
      onClick={handleChangeStatus}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ActivateUserButton = ({ userId }: IActivateUserButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label={`Activate User`} onClick={handleOpenDialog} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Activate The User</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to Activate the user ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton userId={userId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ActivateUserButton;
